import { motion } from "framer-motion";
import { REPLAY_CONFIG } from "@/config/replay";

const CORE = [
  "WEBINAR REPLAY",
  "LEAD GENERATION",
  "FOLLOW-UP SYSTEMS",
  "AUTOMATION",
  "STRATEGY CALL",
];

export default function ReplayTicker() {
  const items = [REPLAY_CONFIG.WEBINAR_TITLE, ...CORE].filter(Boolean);
  if (items.length === 0) return null;
  const row = items.concat(items).concat(items);
  return (
    <section
      aria-label="Topics ticker"
      className="relative overflow-hidden border-y wam-hairline py-8 md:py-10"
      data-testid="replay-ticker"
    >
      <motion.div
        className="flex whitespace-nowrap"
        animate={{ x: ["0%", "-50%"] }}
        transition={{ duration: 55, ease: "linear", repeat: Infinity }}
      >
        {[...row, ...row].map((t, i) => (
          <span
            key={i}
            className="mx-4 md:mx-6 font-display flex items-center gap-4 md:gap-6"
            style={{
              fontSize: "clamp(22px, 3.4vw, 42px)",
              lineHeight: 1,
              letterSpacing: "-0.02em",
              color: "transparent",
              WebkitTextStroke: "1px rgba(240,236,228,0.28)",
            }}
          >
            {t}
            <span className="text-[#C9A84C]" style={{ WebkitTextStroke: 0 }}>
              ◆
            </span>
          </span>
        ))}
      </motion.div>
    </section>
  );
}
